import { m as max, a as min } from './math-DYbrqK2d.js';

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

export { withinMaxClamp as a, within as w };
//# sourceMappingURL=within-CTMPIT1Y.js.map
